const { postMethod, putMethod, deleteMethod, getMethod } = require('../common/api');

export const createPromoCodeApi = async (body) => {
  return postMethod('/api/promo-code', body);
};

export const updatePromoCodeApi = async (body) => {
  return putMethod('/api/promo-code', body);
};

export const isPromoCodeUnique = async (params) => {
  return getMethod('/api/promo-code/unique', params);
};

export const deletePromoCodeApi = async (listingId) => {
  return deleteMethod(`/api/promo-code`, { listingId });
};

export const validatePromoCodeApi = async (params) => {
  return getMethod('/api/promo-code/validate', params);
};
